export default {
    ROWS_PER_PAGE_OPTIONS: [30, 50, 100]
} 
